import { Button, CircularProgress } from "@mui/material";
import colors from "../../config/colors";

const baseStyles = {
  borderRadius: "4px",
  padding: "14px 32px",
  textTransform: "none",
  boxShadow: "none",
  fontFamily: "Lexend, sans-serif",
  fontSize: "16px",
  fontWeight: 500,
  lineHeight: "20px",
  letterSpacing: "0.2px",
};

const variantStyles = {
  primary: {
    backgroundColor: colors.primary500,
    color: colors.white,
    border: "none",
  },
  secondary: {
    backgroundColor: colors.white,
    color: colors.primary500,
    outline: `1px solid ${colors.primary500}`,
  },
};

const disabledStyles = {
  "&.Mui-disabled": {
    backgroundColor: colors.gray100,
    color: colors.gray200,
    border: "none",
  },
};

const TrackingButton = ({
  padding = "14px 32px",
  fontSize = "16px",
  lineHeight = "20px",
  borderRadius = "4px",
  fontWeight = 500,
  children,
  variant = "primary",
  loading = false,
  disabled = false,
  sx: sxOverride,
  backgroundColor,
  color,
  borderColor,
  ...props
}) => {
  return (
    <Button
      disabled={loading || disabled}
      sx={{
        ...baseStyles,
        ...variantStyles[variant],
        ...disabledStyles,
        ...sxOverride,
        padding: padding,
        borderRadius: borderRadius,
        fontSize: fontSize,
        lineHeight: lineHeight,
        fontWeight: fontWeight,
        backgroundColor:
          backgroundColor || variantStyles[variant].backgroundColor,
        color: color || variantStyles[variant].color,
        ...(borderColor && { outline: `1px solid ${borderColor}` }),
      }}
      {...props}
    >
      {loading ? <CircularProgress size={20} color="inherit" /> : children}
    </Button>
  );
};

export default TrackingButton;
